import { useCustomerMembershipContext } from "./CustomerMembershipContext";
import PhoneNumber from "../../formatting/PhoneNumber";
import styled from "styled-components";

export const CustomerInfoWrapper = styled.div`
  table th {
    padding-right: 0.75em;
  }

  table td {
    word-wrap: anywhere;
    text-align: left;
  }
`;

export default function CustomerInfo() {
  const { customer } = useCustomerMembershipContext();

  return (
    <CustomerInfoWrapper>
      <table>
        <tbody>
          <tr>
            <th>Navn</th>
            <td>
              {customer.basic.firstName} {customer.basic.lastName}
            </td>
          </tr>
          <tr>
            <th>E-post</th>
            <td>{customer.basic.email}</td>
          </tr>
          <tr>
            <th>Mobil</th>
            <td>
              <PhoneNumber number={customer.basic.mobilePhone} />
            </td>
          </tr>
          <tr>
            <th>Medlemsnr.</th>
            <td>{customer.customerId}</td>
          </tr>
        </tbody>
      </table>
    </CustomerInfoWrapper>
  );
}
